import { makeStyles, Theme } from '@material-ui/core/styles';

const styles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
  },
  divItems: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  formControl: {
    marginRight: 0,
    marginLeft: 0,
    marginTop: 10,
    marginBottom: 10,
    minWidth: 200,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'absolute',
    bottom: '0',
    right: '0',
    width: '100%',
    marginRight: '16px',
    zIndex: 1,
    background: 'white',
    padding: '15px',
  },
  button: {
    margin: '4px',
  },
  fullWidth: {
    width: '100%',
    minWidth: '362px',
    padding: '10px',
    fontSize: '0.5rem',
  },
  scrollY: {
    overflowY: 'auto',
  },
  paddingBottom: {
    paddingBottom: '20px',
  },
  containerDialogTitle: {
    padding: '10px',
    paddingBottom: '20px',
  },
}));

export default styles;
